<template>
  <main class="index" v-bind:style="{height: heightSet}">
    <menu-button></menu-button>
    <h1><img src="@/assets/img/common/logo_index.svg" alt="advision"></h1>
    <global-nav></global-nav>
  </main>
</template>

<style lang="scss" src="@/assets/scss/index.scss" scoped></style>

<script>
// @ is an alias to /src
import MenuButton from '@/components/MenuButton'
import GlobalNav from '@/components/GlobalNav'
// 親子関係のないコンポーネントに関数を渡すための設定
import eventHub from '@/main'

export default {
  data() {
    return {
      winH: window.innerHeight,
      footerH: 0
    }
  },
  components: {
    MenuButton,
    GlobalNav
  },
  mounted() {
    var self = this
    this.$nextTick(function() {
      var footer = document.getElementsByTagName('footer')[0]
      self.footerH = footer.clientHeight
    })
    // 親子関係のないコンポーネントに関数を渡すための設定
    eventHub.$on('setFooterH', this.setFooterH)
  },
  computed: {
    heightSet: function() {
      return (this.isMobile() && this.winH > 650) ? this.winH - this.footerH + 'px' : null;
    }
  },
  methods: {
    isMobile: function(){
      var regexp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      return (window.navigator.userAgent.search(regexp) !== -1);
    },
    setFooterH: function() {
      var self = this
      // Vue.$nextTick：DOM更新後に実行
      this.$nextTick(function() {
        var footer = document.getElementsByTagName('footer')[0]
        self.footerH = footer.clientHeight
      })
    }
  }
}
</script>
